import { Link } from '@tanstack/react-router'
import { CheckCircle2, FileText } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { MeetingEndReason } from '@hub/contracts'
import { Button } from '@/components/ui/button'

/**
 * The `/meet/$code` link keeps working after the meeting (PLAN-085 §1.4):
 * it explains what happened and points at the notes.
 */
export function EndedScreen({
  projectId,
  reason,
  notesDocumentId,
}: {
  projectId: string
  reason: MeetingEndReason | null
  notesDocumentId: string | null
}) {
  const { t } = useTranslation('meet')
  return (
    <div className="flex h-full flex-1 items-center justify-center p-10">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <CheckCircle2 className="h-8 w-8 text-emerald-500" />
        <h1 className="text-lg font-semibold">{t('ended.title')}</h1>
        <p className="text-muted-foreground text-sm">{t(`ended.${reason ?? 'rtk'}`)}</p>
        <p className="text-muted-foreground text-xs">{t('ended.notesPending')}</p>
        <div className="mt-2 flex gap-2">
          {notesDocumentId && (
            <Button asChild>
              <Link to="/$projectId/write/$docId" params={{ projectId, docId: notesDocumentId }}>
                <FileText className="mr-1.5 h-3.5 w-3.5" />
                {t('ended.notes')}
              </Link>
            </Button>
          )}
          <Button asChild variant="outline">
            <Link to="/$projectId/calendar" params={{ projectId }}>
              {t('ended.back')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
